var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsNotificationCheckmarkSecondary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#008200"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm4.902 5.5l-7.098 7.071-2.71-2.702-1.969 1.965 4.68 4.666 9.07-9.038L16.902 6.5z",
    transform: "translate(-982 -716) translate(982 522) translate(0 165) translate(0 29)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsNotificationCheckmarkSecondary);
export default __webpack_public_path__ + "static/media/icons-notification-checkmark-secondary.20f5be21191da43bc58d01e5892585ca.svg";
export { ForwardRef as ReactComponent };